import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'
import * as models from '../models'

/** TODO:  */
export const onDeleteDataRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.deleteData.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.switchMap(([action, context]) => {
        const {
          data: { chartId, modelId, recordId },
        } = action

        if (chartId && models.Chart.Entry.tryGet(chartId) === 'proposed') {
          return rxjs.of(
            feature.actions.deleteData.success
              .from(action)
              .create({ request: action.data }),
          )
        }

        // Without context, the action is canceled and all relayed operations
        // are consequently canceled
        if (!context) {
          return rxjs.of(
            feature.actions.deleteData.cancellation.from(action).create({
              reason: 'Context not available',
              request: action.data,
            }),
          )
        }

        return gql.mutations.deleteTreeEditorData
          .executor({
            ...context,
            deletion: {
              ids: [recordId],
              modelId,
            },
          })
          .pipe(
            // handle successes
            rxjs.map(() =>
              feature.actions.deleteData.success
                .from(action)
                .create({ request: action.data }),
            ),
            rxjs.catchError(error =>
              // handle error
              rxjs.of(
                feature.actions.deleteData.error
                  .from(action)
                  .create({ error, request: action.data }),
              ),
            ),
          )
      }),
    ),
)
